import Module from './Module';
import StateModule from './StateModule';
import Router from '../../Router';
import * as log from 'loglevel';

class RouterModule extends Module{
	constructor(bootstrap){
		super(bootstrap);

		this.router = new Router();

		this.catchAll 	  = this.catchAll.bind(this);
		this.stateChanged = this.stateChanged.bind(this);
		this.routed 	  = this.routed.bind(this);

		this.dependencies.add(StateModule);
	}

	get enabled(){ return this._enabled; }
	set enabled(enabled){
		if(this._enabled != enabled){
			this._enabled = enabled;
			if(enabled){
				this.router.routed(this.routed);
				this.router.catchAll(this.catchAll);
				this.bootstrap.get(StateModule).on('change', this.stateChanged);
			}
			else{
				this.router.removeRouted(this.routed);
				this.router.removeCatchAll(this.catchAll);
				this.bootstrap.get(StateModule).off('change', this.stateChanged);
			}
		}
	}

	get current(){
		return this.router.current;
	}

	get previous(){
		return this.router.previous;
	}

	add(pattern, handler){
		return this.router.add(pattern, handler);
	}

	remove(route){
		this.router.remove(route);
	}

	set(url){
		this.router.set(url);
	}

	async before(){
		let stateModule = this.bootstrap.get(StateModule);
		if(!stateModule.state || !stateModule.state.url){
			stateModule.state.url = this.router.current.toString();
		}
	}

	routed(url){
		if(!this.router.previous.equals(this.router.current)){
			log.debug('routeChanged', url);
			let stateModule = this.bootstrap.get(StateModule);
			let state = stateModule.state;

			state.url = this.router.current.toString();
			stateModule.state = state;
			return true;
		}
		return false;
	}

	catchAll(url){
		if(this.routed(url))
			this.bootstrap.run();
	}

	stateChanged(state){
		log.debug('stateChanged', state);
		this.router.set(state && state.url ? state.url : '');
	}
}

export default RouterModule;
export { RouterModule };